// extracted by mini-css-extract-plugin
module.exports = {"highlightsContainer":"WeatherHighlights_highlightsContainer__1wrqg","row":"WeatherHighlights_row__32c1w"};